import React, { useState, useEffect } from "react";
import api from "../../api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { FaSearch, FaFilePdf } from "react-icons/fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const SchoolLeavingCertificate = () => {
  const [form, setForm] = useState({
    exam_id: "",
    class_id: "",
    section_id: "",
  });

  const [exams, setExams] = useState([]);
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [marksheets, setMarksheets] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🟩 Toast Function
  const showToast = (type, message) => {
    const options = {
      position: "top-right",
      autoClose: 2000,
      theme: "colored",
      pauseOnHover: true,
    };
    switch (type) {
      case "success":
        toast.success(message, options);
        break;
      case "error":
        toast.error(message, options);
        break;
      case "warning":
        toast.warning(message, options);
        break;
      default:
        toast.info(message, options);
    }
  };

  // 🟦 Initial Fetch
  useEffect(() => {
    fetchExams();
    fetchClasses();
  }, []);

  // 🟦 Fetch Exams
  const fetchExams = async () => {
    try {
      const res = await api.get("/exam-management/list");
     if (res.data?.status && res.data.data.length) {

  setExams(res.data.data);

  setForm((prev) => ({
    ...prev,
    exam_id: res.data.data[0],
  }));

        showToast("success", "Exams loaded successfully!");
      } else {
        setExams([]);
        showToast("warning", "No exams found!");
      }
    } catch {
      showToast("error", "Failed to load exams");
    }
  };

  // 🟦 Fetch Classes
  const fetchClasses = async () => {
    try {
      const res = await api.get("/get-classes");
      if (res.data?.success && res.data.data.length) {
        setClasses(res.data.data);
        showToast("success", "Classes loaded successfully!");
      } else {
        setClasses([]);
        showToast("warning", "No classes found!");
      }
    } catch {
      showToast("error", "Failed to load classes");
    }
  };

  // 🟦 Fetch Sections
  const fetchSections = async (classId) => {
    try {
      const res = await api.get(`/get-sections/${classId}`);
      if (res.data?.success && res.data.data.length) {
        setSections(res.data.data);
        showToast("success", "Sections loaded!");
      } else {
        setSections([]);
        showToast("warning", "No sections found!");
      }
    } catch {
      setSections([]);
      showToast("error", "Failed to load sections");
    }
  };

  // 🟩 Handle Input Change
  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
    if (field === "class_id" && value) {
      fetchSections(value.id);
      setForm({ ...form, class_id: value, section_id: "" });
    }
  };

  // 🟦 Fetch Marksheet List
  const handleSearch = async () => {
    if (!form.class_id || !form.section_id) {
      showToast("error", "Please select all filters!");
      return;
    }

    setLoading(true);
    try {
      const res = await api.get("/student/mark-sheet/list", {
        params: {
          exam_id: form.exam_id.id,
          class_id: form.class_id.id,
          section_id: form.section_id.id,
        },
      });

      if (res.data?.success && res.data.data.length) {
        setMarksheets(res.data.data);
        showToast("success", "Marksheet list loaded successfully!");
      } else {
        setMarksheets([]);
        showToast("warning", "No marksheet found!");
      }
    } catch {
      showToast("error", "Failed to fetch marksheet list!");
    } finally {
      setLoading(false);
    }
  };
  const generateMarksheet = async (student_id, exam_id) => {
    try {
      const res = await api.get(`/student/mark-sheet/view/${student_id}/${exam_id}`);

      if (!res.data?.success) {
        showToast("error", "Failed to generate marksheet!");
        return;
      }

      const data = res.data.data;

      const schoolId = Number(data.school?.id || 0);
      const classId = Number(data.student.class_id || 0);

      const schoolLogo = data.school.logo
        ? `https://dgps.co.in/public/admin/assets/img/schools/logo/${data.school.logo}`
        : "https://dgps.co.in/public/admin/assets/img/logo.png";

      const studentPhoto =
        data.student.file && data.student.file !== ""
          ? data.student.file
          : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png";

      // ============================
      //  COMMON: MARK TYPE HEADERS
      //  (main + extra মিলিয়ে, default ডিজাইনের জন্য)
      // ============================
      const markTypeHeaders = (() => {
        const allSubjects = [...(data.subjects.main || []), ...(data.subjects.extra || [])];
        const allItems = allSubjects.flatMap((s) => s.items || []);
        const uniqueTypes = [];

        allItems.forEach((i) => {
          if (!uniqueTypes.find((u) => u.mark_type_id === i.mark_type_id)) {
            uniqueTypes.push({
              mark_type_id: i.mark_type_id,
              title: i.title || "Type",
            });
          }
        });

        return uniqueTypes;
      })();

      // ==========================================================
      //  SPECIAL DESIGN : DGPS (school_id === 1) – SCREENSHOT STYLE
      // ==========================================================
      
     if (schoolId === 1 || schoolId === 30) {

const bgImage =
  "https://dgps.co.in/public/certificates.png"; 
       const hmSignature =
  schoolId === 30
    ? "https://dgps.co.in/uploads/signature/teachers/ssss.png"
    : Number(classId) >= 1 && Number(classId) <= 6
      ? "https://dgps.co.in/uploads/signature/bl_hm.png"
      : "https://dgps.co.in/uploads/signature/upper_hm.png";


       const subjectOrder = [
  "bengali",
  "english",
  "arabic",
  "hindi",
  "arabic hindi",
  "arabic/hindi",
  "mathematics",
  "math",
  "science",
  "history",
  "geography",
  "gk",
  "conversation",
  "gk/conversation"
];

const normalizeSubject = (name) =>
  (name || "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ");

const mainSubjects = [...(data.subjects.main || [])].sort((a, b) => {
  const aName = normalizeSubject(a.subject_name);
  const bName = normalizeSubject(b.subject_name);

  const getIndex = (name) => {
    if (name.includes("bengali")) return 0;
    if (name.includes("english")) return 1;
    if (
      name.includes("arabic") ||
      name.includes("hindi")
    ) return 2;
    if (
      name.includes("mathematics") ||
      name.includes("math")
    ) return 3;
    if (name.includes("science")) return 4;
    if (name.includes("history")) return 5;
    if (name.includes("geography")) return 6;
    if (
      name.includes("gk") ||
      name.includes("conversation")
    ) return 7;

    return 999;
  };

  return getIndex(aName) - getIndex(bName);
});
        const extraSubjects = data.subjects.extra || [];
        const otherSubjects = data.subjects?.other || [];
     const formatSubjectName = (name) => {
  // শুধু school_id = 30 এর জন্য 1st/2nd/3rd Language দেখাবে
  if (schoolId === 30) {
    const subject = (name || "").trim().toLowerCase();

    if (subject.includes("bengali")) {
      return "Bengali (1st Language)";
    }

    if (subject.includes("english")) {
      return "English (2nd Language)";
    }

    if (
      subject.includes("arabic") ||
      subject.includes("hindi")
    ) {
      return "Arabic Hindi (3rd Language)";
    }
  }

  // অন্যান্য সব school-এ subject name যেমন আছে তেমনই থাকবে
  return name;
};
        const totalMainFull = mainSubjects.reduce(
          (sum, s) => sum + Number(s.total_marks || 0),
          0
        );
        const totalMainObt = mainSubjects.reduce(
          (sum, s) => sum + Number(s.marks_obtained || 0),
          0
        );
        const totalMainHighest = mainSubjects.reduce(
          (sum, s) => sum + Number(s.highest_marks || 0),
          0
        );

        const percentage =
          data.summary?.percentage ??
          (totalMainFull
            ? Math.round((totalMainObt / totalMainFull) * 100)
            : 0);
            const maxSubjectMarks = Math.max(
  ...mainSubjects.map(sub => Number(sub.total_marks || 0))
);

const gradeRulesToUse =
  maxSubjectMarks <= 40
    ? (data.grade_rules_babyland || [])
    : (data.grade_rules || []);


        // Grade scale box – dynamic from grade_rules
        const gradeScaleRows = gradeRulesToUse
          .map((g) => {
            let min = parseFloat(g.min_percentage);
            let max = parseFloat(g.max_percentage);

            if (isNaN(min) || isNaN(max)) return "";

            // 🔹 Round logic for clean ranges
            const displayMin = Math.round(min);
            const displayMax = Math.floor(max);

            const range = `${displayMin} - ${displayMax}`;

            return `
              <tr>
                <td>${range}</td>
                <td>${g.grade}</td>
              </tr>
            `;
          })
          .join("");

        const currentScaleType =
  gradeRulesToUse.length > 0
    ? gradeRulesToUse[0].scale_type
    : 100;

const gradeTitle = `Grade Scale (${currentScaleType})`;


        // Working days / present – আপাতত blank / API থাকলে use করব
        const workingDays = data.summary?.working_day || "";
        const presentDays = data.student?.present_day || "";

        // Formative evaluation (fixed for now)
        const evalGrades = {
          attendance: "AA",
          attitude: "A+",
          discipline: "AA",
          punctuality: "AA",
          morality: "AA",
          cleanliness: "AA",
          creativity: "A+",
          participation: "A+",
        };

        const examYear = data.exam.start_date
          ? new Date(data.exam.start_date).getFullYear()
          : "";

        const printWin = window.open("", "_blank");

        const termSummary = data.term_summary || null;

        const termSummaryHTML =
          termSummary && data.exam.exam_type === "final"
            ? `
    <table class="term-summary">
      <tr>
        <th>Exams</th>
        <th>Full Marks</th>
        <th>Marks Obtained</th>
      </tr>
      <tr>
        <td><b>1st Term Total</b></td>
        <td>${termSummary.term_1.total_marks}</td>
        <td>${termSummary.term_1.marks_obtained}</td>
      </tr>
      <tr>
        <td><b>2nd Term Total</b></td>
        <td>${termSummary.term_2.total_marks}</td>
        <td>${termSummary.term_2.marks_obtained}</td>
      </tr>
      <tr>
        <td><b>Annual Total</b></td>
        <td>${data.summary.total_marks}</td>
        <td>${data.summary.marks_obtained}</td>
      </tr>
      <tr>
        <td><b>Overall Total</b></td>
        <td>${termSummary.overall.total_marks}</td>
        <td>${termSummary.overall.marks_obtained}</td>
      </tr>
      <tr>
        <td><b>Overall Percentage</b></td>
        <td colspan="2"><b>${termSummary.overall.percentage.toFixed(2)}% </b></td>
      </tr>
      
    </table>
    `
            : "";


        printWin.document.write(`
        <html>
        <head>
        <link href="https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&display=swap" rel="stylesheet">
          <title>CERTIFICATE - ${data.student.name}</title>
          <style>
            @page {
              size: A4 portrait;
              margin: 0;
            }
            body {
              margin: 0;
              font-family:  Arial, sans-serif;
              background: #f0f0f0;
            }
            .page {
              position: relative;
              width: 794px;
              height: 1123px;
              margin: 0 auto;
              background: url('${bgImage}') no-repeat center top;
              background-size: 100% 100%;
            }
            .content {
              position: absolute;
              top: 50px;
              left: 70px;
              right: 75px;
              bottom: 80px;
              font-size: 12px;
              padding: 10px !important;
            }
            /* TOP SCHOOL HEADER (NEW) */
            .school-head {
              text-align: center;
              margin-top: 5px;
            }
            .school-head-name {
              font-family: 'Oswald', sans-serif;
              font-weight: 700; /* Bold */
              font-size: 36px;
              letter-spacing: 1px;
              text-align: center;
            }
            .school-head-sub {
              font-size: 15px;
              margin-top: 2px;
              font-weight: bold;
            }
            .school-separator {
              border: none;
              border-top: 2px solid #000;
              margin: 10px 0;
            }
            .title-line {
              text-align: center;
              font-weight: 700;
              font-size: 13px;
              margin-top: 10px;
            }
            .student-line {
              margin-top: 8px;
              font-size: 15px;
            }
            .student-line b {
              font-weight: 700;
            }
           .flex-row {
  width: 100%;
  margin-top: 10px;
}
          .left-section {
  width: 100%;
}
        
            .footer-sign {
              position: absolute;
              bottom: 0px;
              left: 60px;
              right: 60px;
              display: flex;
              justify-content: space-between;
              font-size: 11px;
            }

            /* 🔹 each signature column */
            .sign-box {
              width: 160px;
              text-align: center;
            }

            /* 🔹 signature image container */
            .sign-space {
              width: 140px;
              height: 60px;
              margin: 0 auto 6px;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            /* 🔹 signature image */
            .sign-space img {
              max-width: 100%;
              max-height: 100%;
              object-fit: contain;
            }

            /* 🔹 label line */
            .sign-label {
              padding-top: 4px;
              font-weight: 600;
            }

          </style>
        </head>
        <body>
          <div class="page">
            <div class="content">
              <!-- SCHOOL HEADER (TOP) -->
                <div class="school-head">

              <img
  src="${schoolLogo}"
  alt="Logo"
  class="school-logo"
  style="
    width:90px !important;
    height:90px !important;
    max-width:90px !important;
    max-height:90px !important;
    margin-top:10px;
    object-fit:contain !important;
  "
/>

                <div class="school-head-name">
                    ${data.school.name}
                </div>

                <div style="font-size: 17px;" class="school-address">
                    ${data.school.address || ""}
                </div>

                <div  style="font-size:17px;" class="school-contact">
                    Mobile : ${data.school.phone || ""}
                    ${
                    data.school.email
                        ? ` | Email : ${data.school.email}`
                        : ""
                    }
                </div>
                 <hr/ class="school-separator" />

                <div  style="font-size: 20px; font-weight: bold;" class="certificate-title">
                    SCHOOL LEAVING CERTIFICATE
                </div>

                </div>
             

              <div class="flex-row">
               <div class="left-section">
               <div style="
display:flex;
justify-content:space-between;
align-items:flex-start;
gap:20px;
">

<div style="flex:1;">

  <div style="
    margin-top:15px;
    font-size:14px;
    display:flex;
    justify-content:space-between;
  ">
    <span>Certificate No : SLC-${data.student.id}</span>
    <span>Date : ${new Date().toLocaleDateString("en-IN")}</span>
  </div>

 <div style="
  margin-top:25px;
  font-size:15px;
  line-height:1.9;
  width:100%;
  display:block;
">

<p>
This is to certify that <b>${data.student.name}</b>,
Son / Daughter of <b>${data.student.father_name}</b>
and <b>${data.student.mother_name}</b>,
was a bonafide student of <b>${data.school.name}</b>.
</p>

<p>
The student was admitted on
<b>${data.student.created_at?.split(" ")[0] || ""}</b>
and studied up to Class <b>${data.student.class_name}</b>.
The student has now left this institution and this certificate
is issued at the request of the parent/guardian.
</p>

    <br>
    <div style="
display:flex;
justify-content:space-between;
align-items:flex-start;
margin-top:25px;
">
<div style="
width:70%;
// background:rgba(255,255,255,0.45);
// border:2px solid #1e40af;
border-radius:12px;
padding:18px;
// box-shadow:0 3px 10px rgba(0,0,0,.15);
    margin-bottom: -50px;

">

<div style="
font-size:17px;
font-weight:700;
text-align:center;
color:#1e40af;
margin-top:-83px;
margin-bottom:12px;
border-bottom:2px solid #1e40af;
padding-bottom:8px;
">
STUDENT DETAILS
</div>

<div style="
display:grid;
grid-template-columns:190px 1fr;
row-gap:8px;
column-gap:8px;
font-size:16px;
line-height:1.5;
">

<div><b>Date of Birth</b></div>
<div>: <b>${data.student.dob || ""}</b></div>

<div><b>Gender</b></div>
<div>: <b>${data.student.gender || ""}</b></div>

<div><b>Father's Name</b></div>
<div>: <b>${data.student.father_name || ""}</b></div>

<div><b>Mother's Name</b></div>
<div>: <b>${data.student.mother_name || ""}</b></div>

${data.student.aadhaar_no ? `
<div><b>Aadhaar No</b></div>
<div>: <b>${data.student.aadhaar_no}</b></div>
` : ''}

${data.student.category ? `
<div><b>Category</b></div>
<div>: <b>${data.student.category}</b></div>
` : ''}

${data.student.blood_group ? `
<div><b>Blood Group</b></div>
<div>: <b>${data.student.blood_group}</b></div>
` : ''}
<div><b>Class</b></div>
<div>: <b>${data.student.class_name || ""}</b></div>
<div><b>Roll No</b></div>
<div>: <b>${data.student.roll_no || ""}</b></div>

<div><b>Section</b></div>
<div>: <b>${data.student.section_name || ""}</b></div>

</div>

</div>

<div style="
width:125px;
background:#fff;
padding:8px;
border-radius:12px;
border:3px solid #1e40af;
box-shadow:0 4px 12px rgba(0,0,0,.20);
text-align:center;
">

<img
src="${studentPhoto}"
style="
width: 112px;
height: 133px;
border-radius:8px;;
object-fit:cover;
border:1px solid #000;
"
/>

</div>

</div>

    <br>

    The conduct and character of the student during
    his/her stay in this institution was found to be
    <b>GOOD</b>.

    <br>

  Reason For Leaving :
<b>At Parent's Request</b>

    <br>

    We wish him/her every success in future life.

  </div>
  

</div>

</div>
               

</div>
              <div class="footer-sign">
                <!-- Class Teacher (Empty) -->
                <div class="sign-box">
  <div class="sign-space">

${
  schoolId === 1
    ? (() => {

        let cls = String(data.student.class_name || "")
          .trim()
          .toUpperCase()
          .replace(/\s+/g, "");

        let sec = String(data.student.section_name || "")
          .trim()
          .toUpperCase()
          .replace(/\s+/g, "");

        let fileName = "";

        // Nursery special
        if (cls === "NURSERY") {
          fileName = "nursery.png";
        } else {
          fileName = `${cls}-${sec}.png`;
        }

        const imgUrl = `https://dgps.co.in/uploads/signature/teacher/${fileName}`;

        return `
          <img 
            src="${imgUrl}" 
            alt=""
            onerror="this.style.display='none'"
          />
        `;

      })()
    : ""
}

  </div>

  <div class="sign-label">
    Signature of Class Teacher
  </div>
</div>

                <!-- Headmaster (With Signature) -->
                <div class="sign-box">
                  <div class="sign-space">
                    <img src="${hmSignature}" alt="Headmaster Signature" />
                  </div>
                  <div class="sign-label">Signature of Headmaster</div>
                </div>
              </div>

            </div>
          </div>

          <script>
            window.print();
            window.onafterprint = () => window.close();
          </script>
        </body>
        </html>
      `);

        printWin.document.close();
        return;
      }

      // =====================================
      //  DEFAULT DESIGN (OTHER SCHOOLS)
      //  — আপনার আগের ডিজাইন একদম 그대로
      // =====================================
      const printWin = window.open("", "_blank");

      printWin.document.write(`
      <html>
      <head>
        <title>School Leaving Certificate - ${data.student.name}</title>
        <style>
          @page {
            size: A4 portrait;
            margin: 10mm;
          }

          body {
            font-family: "Poppins", Arial, sans-serif;
            margin: 0;
            background: #f8faff;
            color: #000;
          }

          .border {
            border: 10px double #0056d6;
            padding: 25px 35px;
            background: #fff;
            border-radius: 8px;
            max-width: 800px;
            margin: auto;
            box-shadow: 0 4px 8px rgba(0,0,0,0.15);
          }
          .school-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 2px solid #0056d6;
            padding-bottom: 10px;
            margin-bottom: 15px;
          }

          .school-logo {
            width: 90px;
            height: 90px;
            object-fit: contain;
          }

          .school-text {
            flex-grow: 1;
            text-align: center;
          }

          .school-name {
            font-size: 24px;
            font-weight: 800;
            color: #003a80;
            text-transform: uppercase;
          }

          .school-contact {
            font-size: 20px;
            color: #444;
            line-height: 1.4;
          }
            

          .certificate {
            color: #00723e;
            font-weight: 700;
            text-decoration: underline;
            font-size: 15px;
            margin-top: 5px;
            text-align: center;
          }

       

          .student-box {
            border: 1px solid #0056d6;
            background: #f9fbff;
            padding: 12px;
            border-radius: 6px;
            display: grid;
            grid-template-columns: 1fr 130px;
            gap: 20px;
            margin-bottom: 20px;
          }
                      .body-copy{
            width:100%;
            display:block;
            font-size:15px;
            line-height:1.8;
            text-align:justify;
          }

          .info-table td {
            padding: 6px;
            font-size: 13px;
            border-bottom: 1px dashed #999;
          }

          .info-table td:first-child {
            font-weight: 600;
            color: #003a80;
          }

          .photo-box {
            width: 130px;
            height: 150px;
            border: 2px solid #007bff;
            overflow: hidden;
            border-radius: 8px;
          }

          .marks-table th {
            background: #d7e9ff;
            border: 1px solid #0056d6;
            padding: 8px;
            font-size: 13px;
          }

          .marks-table td {
            border: 1px solid #9dbdfc;
            padding: 6px;
            font-size: 13px;
            text-align: center;
          }

          .summary-title {
            background: #dce8ff;
            border: 1px solid #0056d6;
            text-align: center;
            padding: 6px;
            font-weight: 700;
            margin-top: 25px;
          }

          .summary-table td,
          .summary-table th {
            border: 1px solid #9dbdfc;
            padding: 6px;
            font-size: 13px;
            text-align: center;
          }

          .footer {
            display: flex;
            justify-content: space-between;
            margin-top: 40px;
            font-weight: 600;
            color: #0056d6;
          }

          .result-tag {
            margin-top: 20px;
            background: linear-gradient(90deg, #007bff, #00c6ff);
            color: white;
            padding: 6px 20px;
            border-radius: 20px;
            display: inline-block;
          }
        </style>
      </head>

      <body>
      <div class="border">
        <!-- HEADER -->
        <div class="school-header">
          <img src="${schoolLogo}" class="school-logo" alt="Logo"/>
          <div class="school-text">
            <div class="school-name">${data.school.name}</div>
            <div class="school-contact">
              ${data.school.address}<br>
              ${data.school.phone ? "Phone: " + data.school.phone + " | " : ""}
              ${data.school.email ? data.school.email : ""}
            </div>
            <div class="certificate">CERTIFICATE OF MARKS</div>
            <div class="exam-title">${data.exam.exam_name.toUpperCase()}</div>
          </div>
        </div>

      <div style="
display:flex;
justify-content:space-between;
align-items:flex-start;
margin-top:25px;
">

    <!-- Student Information Card -->
    <div style="
    width:72%;
    background:rgba(255,255,255,0.75);
    border:2px solid #1e3a8a;
    border-radius:12px;
    padding:18px;
    box-shadow:0 4px 15px rgba(0,0,0,.15);
    ">

        <div style="
        font-size:18px;
        font-weight:700;
        text-align:center;
        color:#1e3a8a;
        margin-bottom:15px;
        border-bottom:2px solid #1e3a8a;
        padding-bottom:8px;
        ">
            STUDENT INFORMATION
        </div>

        <table style="
        width:100%;
        border-collapse:collapse;
        font-size:15px;
        ">
        
            <tr>
                <td style="padding:8px;font-weight:700;width:35%;">Date of Birth</td>
                <td style="padding:8px;">: ${data.student.dob || ''}</td>
            </tr>

            ${data.student.gender ? `
            <tr>
                <td style="padding:8px;font-weight:700;">Gender</td>
                <td style="padding:8px;">: ${data.student.gender}</td>
            </tr>` : ''}

            <tr>
                <td style="padding:8px;font-weight:700;">Father's Name</td>
                <td style="padding:8px;">: ${data.student.father_name || ''}</td>
            </tr>

            <tr>
                <td style="padding:8px;font-weight:700;">Mother's Name</td>
                <td style="padding:8px;">: ${data.student.mother_name || ''}</td>
            </tr>

            ${data.student.aadhaar_no ? `
            <tr>
                <td style="padding:8px;font-weight:700;">Aadhaar No</td>
                <td style="padding:8px;">: ${data.student.aadhaar_no}</td>
            </tr>` : ''}

            ${data.student.category ? `
            <tr>
                <td style="padding:8px;font-weight:700;">Category</td>
                <td style="padding:8px;">: ${data.student.category}</td>
            </tr>` : ''}

            ${data.student.blood_group ? `
            <tr>
                <td style="padding:8px;font-weight:700;">Blood Group</td>
                <td style="padding:8px;">: ${data.student.blood_group}</td>
            </tr>` : ''}

            <tr>
                <td style="padding:8px;font-weight:700;">Roll No</td>
                <td style="padding:8px;">: ${data.student.roll_no || ''}</td>
            </tr>

            <tr>
                <td style="padding:8px;font-weight:700;">Section</td>
                <td style="padding:8px;">: ${data.student.section_name || ''}</td>
            </tr>

        </table>

    </div>

    <!-- Student Photo Card -->
    <div style="
    width:190px;
    text-align:center;
    ">

        <div style="
        background:#fff;
        border:3px solid #1e3a8a;
        border-radius:12px;
        padding:10px;
        box-shadow:0 4px 15px rgba(0,0,0,.2);
        ">

            <img
            src="${studentPhoto}"
            style="
            width:150px;
            height:180px;
            object-fit:cover;
            border-radius:8px;
            border:2px solid #ddd;
            "
            />

            <div style="
            margin-top:8px;
            font-size:13px;
            font-weight:700;
            color:#1e3a8a;
            ">
                STUDENT PHOTO
            </div>

        </div>

    </div>

</div>


        <!-- FOOTER -->
        <div class="footer">
          <div>Class Teacher</div>
          <div>Head Master</div>
        </div>

        <center>
          <div class="result-tag">
            Published on: ${new Date().toLocaleDateString("en-IN")}
          </div>
        </center>

      </div>

      <script>
        window.print();
        window.onafterprint = () => window.close();
      </script>

      </body>
      </html>
    `);

      printWin.document.close();
    } catch (err) {
      console.error(err);
      showToast("error", "Something went wrong!");
    }
  };

  const downloadExcel = (rows, fileName = "Class_Marksheet.xlsx") => {
  if (!rows || !rows.length) {
    alert("No data to export");
    return;
  }

  // Convert JSON → Worksheet
  const worksheet = XLSX.utils.json_to_sheet(rows);

  // Auto width
  const colWidths = Object.keys(rows[0]).map((key) => ({
    wch: Math.max(
      key.length,
      ...rows.map((r) => String(r[key] ?? "").length)
    ) + 2,
  }));
  worksheet["!cols"] = colWidths;

  // Workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Marksheet");

  // Export
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(blob, fileName);
};


const downloadClassMarksheetExcel = async () => {
  if (!form.exam_id || !form.class_id || !form.section_id) {
    showToast("error", "Please select Exam, Class and Section");
    return;
  }

  try {
    setLoading(true);

    const res = await api.post(
      "/student/mark-sheet/class_wise",
      {
        exam_id: form.exam_id.id,
        class_id: form.class_id.id,
        section_id: form.section_id.id,
      }
    );

    if (!res.data?.success || !res.data.data?.length) {
      showToast("warning", "No data found");
      return;
    }

    const examName = form.exam_id.exam_name.replace(/\s+/g, "_");
    const className = form.class_id.class_name.replace(/\s+/g, "_");
    const sectionName = form.section_id.section_name;

   

    showToast("success", "Excel downloaded successfully!");
  } catch (err) {
    console.error(err);
    showToast("error", "Failed to download Excel");
  } finally {
    setLoading(false);
  }
};


  return (
    <div style={styles.page}>
      <ToastContainer />
      <h2 style={styles.title}>🎓 School Leaving Certificate</h2>

      {/* Filter Section */}
      <div style={styles.card}>
        <div style={styles.filterRow}>
          {/* <div style={styles.filterItem}>
            <label style={styles.label}>Exam</label>
            <Select
              getOptionLabel={(e) => e.exam_name}
              getOptionValue={(e) => e.id}
              options={exams}
              value={form.exam_id}
              onChange={(v) => handleChange("exam_id", v)}
              placeholder="Select Exam"
            />
          </div> */}

          <div style={styles.filterItem}>
            <label style={styles.label}>Class</label>
            <Select
              getOptionLabel={(e) => e.class_name}
              getOptionValue={(e) => e.id}
              options={classes}
              value={form.class_id}
              onChange={(v) => handleChange("class_id", v)}
              placeholder="Select Class"
            />
          </div>

          <div style={styles.filterItem}>
            <label style={styles.label}>Section</label>
            <Select
              getOptionLabel={(e) => e.section_name}
              getOptionValue={(e) => e.id}
              options={sections}
              value={form.section_id}
              onChange={(v) => handleChange("section_id", v)}
              placeholder="Select Section"
            />
          </div>

          <button style={styles.btnSearch} onClick={handleSearch}>
            {loading ? "Loading..." : <><FaSearch /> Search</>}
          </button>
                    {/* <button
              style={{
                background: "linear-gradient(90deg,#16a34a,#22c55e)",
                color: "#fff",
                padding: "10px 18px",
                borderRadius: "8px",
                border: "none",
                cursor: "pointer",
                fontWeight: 600,
              }}
              onClick={downloadClassMarksheetExcel}
            >
              📥 Download Excel
          </button> */}
        </div>
        
      </div>

      {/* Result Table */}
      <div style={styles.tableWrapper}>
        {loading ? (
          <p style={styles.noData}>⏳ Fetching data...</p>
        ) : marksheets.length > 0 ? (
          <table style={styles.table}>


            <thead>
              <tr>
                <th>#</th>
                <th>Photo</th>
                <th>Student</th>
                <th>Class</th>
                <th>Section</th>
                <th>Roll</th>
                {/* <th>Exam</th> */}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {marksheets.map((s, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>
                    <img
                      src={
                        s.photo ||
                        "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                      }
                      alt="student"
                      style={styles.photo}
                    />
                  </td>
                  <td>{s.student_name}</td>
                  <td>{s.class_name}</td>
                  <td>{s.section_name}</td>
                  <td>{s.roll_no}</td>
                  <td>
                    <button
                      style={styles.btnView}
                      onClick={() => generateMarksheet(s.id, form.exam_id.id)}
                    >
                      <FaFilePdf /> Generate Certificate
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p style={styles.noData}>No marksheet found</p>
        )}
      </div>
    </div>
  );
};

export default SchoolLeavingCertificate;

const styles = {
  page: {
    padding: "25px",
    backgroundColor: "#f4f7fb",
    minHeight: "100vh",
  },
  title: {
    textAlign: "center",
    fontSize: "22px",
    color: "#2c3e50",
    fontWeight: "700",
    marginBottom: "25px",
  },
  card: {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
    marginBottom: "25px",
  },
  filterRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "15px",
    alignItems: "flex-end",
  },
  filterItem: {
    flex: 1,
    minWidth: "220px",
  },
  label: {
    display: "block",
    marginBottom: "5px",
    fontWeight: "600",
    color: "#333",
    fontSize: "14px",
  },
  btnSearch: {
    background: "linear-gradient(90deg,#007bff,#00c6ff)",
    color: "#fff",
    fontWeight: "600",
    border: "none",
    padding: "10px 18px",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "0.3s",
  },
  tableWrapper: {
    background: "#fff",
    borderRadius: "10px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  photo: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "2px solid #007bff",
  },
  noData: {
    textAlign: "center",
    color: "#777",
    padding: "20px",
    fontStyle: "italic",
  },
  btnView: {
    background: "linear-gradient(90deg,#28a745,#6dd47e)",
    color: "#fff",
    padding: "6px 12px",
    borderRadius: "6px",
    textDecoration: "none",
    fontWeight: "600",
    border: "none",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
  },


};
